// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MW1Fb","label":"styles_label__VDI6v","content":"styles_content__UJzD6","edit":"styles_edit__GxanF"};